import React, {useState} from 'react';
import CartProductVariationItem from "@app/react/components/CartProductVariationItem/CartProductVariationItem.jsx";
import Accordion from 'react-bootstrap/Accordion';

export default function BundleOption({option, cart, onChange}) {
  const optionCart = cart[option.id] ?? {}
  const optionCartQty = Object.values(optionCart).reduce((acc, val) => acc + val, 0)
  const quantityReached = optionCartQty === option.quantity
  const colors = Object.values(
    option.productVariations.reduce((acc, v) => {
      if (v.color && v.color.id && !acc[v.color.id]) acc[v.color.id] = v.color;
      return acc;
    }, {})
  );
  const [selectedColor, setSelectedColor] = useState(null);
  const filteredVariations = selectedColor === null
    ? option.productVariations
    : option.productVariations.filter(v => v.color && v.color.id === selectedColor);

  function toggleColor(colorId) {
    setSelectedColor(prev => prev === colorId ? null : colorId);
  }

  return <Accordion className='bundle-option' defaultActiveKey="0">
    <Accordion.Item eventKey="0">
      <Accordion.Header>
        {option.title}
      </Accordion.Header>
      <Accordion.Body>
        <div className="d-flex justify-content-between">
            <div className='color-filter'>
              {colors.map(color => (
                <button
                  key={color.id}
                  className={'color-chip' + (selectedColor === color.id ? ' active' : '')}
                  onClick={() => toggleColor(color.id)}
                >
                  {color.image && <img src={color.image} alt={color.name} />}
                  {color.name}
                </button>
              ))}
            </div>

          {option.quantity>0 &&
            <div className='bundle-option__qty'>
              <label>{Drupal.tt("q.tà per singola configurazione")}</label>
              <span className={"badge "+(quantityReached?"qty-reached":"text-bg-light")}>{option.quantity}</span>
            </div>
          }
        </div>
        {filteredVariations.map(variation =>
          <CartProductVariationItem productVariation={variation} quantity={optionCart[variation.id] ?? 0}
                                    onChange={qty => onChange(option.id, variation.id, qty)}/>
        )}
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
}
